import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import { resetPassword } from "../../firebase";
import { Button, Text, TextInput } from "react-native-paper";
import { useTranslation } from "react-i18next";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const handleForgotPassword = async () => {
    if (!email) {
      alert(t("Enter your email."));
      return;
    }

    try {
      await resetPassword(email);
      alert(t("Password reset link sent to your email."));
      setEmail("");
    } catch (error) {
      console.error(error);
      alert(
        t(
          "Failed to send password reset link. Please check your email and try again.",
        ),
      );
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.formContainer}>
        <Text>{t("Forgot password")}</Text>
        <TextInput
          mode="outlined"
          placeholder={t("Enter your email")}
          placeholderTextColor="#999"
          keyboardType="email-address"
          autoCapitalize="none"
          autoCorrect={false}
          value={email}
          onChangeText={setEmail}
          autoFocus
        />
        <Button mode="contained" onPress={handleForgotPassword}>
          {t("Restore")}
        </Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
  },
  formContainer: {
    maxWidth: 400,
    width: "100%",
    gap: 20,
    padding: 20,
  },
});

export default ForgotPasswordScreen;
